




import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";

@Component
export default class VuetifyNumberInput extends Vue {
  @Prop({ default: 0 }) value!: number;

  @Prop() label!: string;

  @Emit()
  private input(value: string): number {
    const nam = Number(value);
    if (isNaN(nam)) {
      return 0;
    }
    return nam;
  }

  private get Value(): string {
    if (this.value === 0) {
      return "";
    } else {
      return this.value.toString();
    }
  }

  private set Value(value: string) {
    this.input(value);
  }
}
